import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _noop from "lodash/noop";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import Button from '@datacamp/waffles-button';
import { BulbIcon, CodeIcon } from '@datacamp/waffles-icons';
import React, { useCallback } from 'react';
import useShortcut from '../useShortcut';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
const getButtonIcon = isSolution => isSolution ? CodeIcon : BulbIcon;
const HintAndSolution = _ref => {
  let {
    borderless = false,
    isSolution = false,
    isVisible = true,
    onClick = _noop,
    xp
  } = _ref;
  const {
    t
  } = useTranslation();
  useShortcut({
    disabled: !isVisible,
    handler: onClick,
    shortcut: {
      ctrlKey: true,
      key: 'h'
    }
  });
  const getButtonText = useCallback(() => {
    const action = isSolution ? t('HintAndSolution.showAnswer') : t('HintAndSolution.takeHint');
    const penalty = xp != null ? " (-".concat(xp, " XP)") : '';
    return "".concat(action).concat(penalty);
  }, [isSolution, xp, t]);
  if (!isVisible) {
    return null;
  }
  const ButtonIcon = getButtonIcon(isSolution);
  const buttonText = getButtonText();
  const cy = isSolution ? 'exercise-show-solution' : 'exercise-show-hint';
  const buttonStyle = _objectSpread({}, borderless && {
    border: 'none'
  });
  return ___EmotionJSX(Button, {
    className: "dc-sct-feedback__nav--hint-solution",
    css: buttonStyle,
    dataAttributes: {
      cy
    },
    onClick: onClick,
    size: "small",
    tooltipPosition: "top",
    tooltipText: "Ctrl+H"
  }, ___EmotionJSX(ButtonIcon, null), buttonText);
};
export default HintAndSolution;